import AccordionItemPrimary from "../../common/accordion-item/accordion-item-primary/accordion-item-primary";

const TenderhubSupplierCardSection = () => {
  return (
    <AccordionItemPrimary title="Карточка поставщика">
      Общество с ограниченной ответственностью «СИ ДЖИ СИ» (ООО «СИ ДЖИ СИ»)
      <br />
      ОГРН 1157746948446
      <br />
      ИНН 7734366435 КПП 773401001
      <br />
      Юридический адрес 123308, Москва г, Маршала Жукова пр-кт, дом 4, помещение
      цоколь пом III ком 23
      <br />
      Учреждение банка
      <br />
      АО "АЛЬФА-БАНК"
      <br />
      БИК 044525593
      <br />
      р/с 40702810702870018033
      <br />
      почта: <a href="mailto:info@creon-cg.com">info@creon-cg.com</a> | телефон{" "}
      <a href="tel:+74993723231">+74993723231</a>
    </AccordionItemPrimary>
  );
};

export default TenderhubSupplierCardSection;

